<template>
  <div id="app">
     <BackTop :height="100" :bottom="200">
        <div class="top">返回顶端</div>
    </BackTop>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
*{
	margin:0;
	padding: 0;
}
#app{
background-color: #b4daf7;
background-image: linear-gradient(180deg, #b4daf7 26%, #ffffff 99%);
}
.top{
    padding: 10px;
		background-color:#419ad6;
    color: #fff;
    text-align: center;
    border-radius: 2px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue